import styled, { css } from 'styled-components';
import { minWidth, maxWidth } from '@/assets/styles/mixins.css';
import vars from '@/assets/styles/vars';

const Anchors = styled.ul`
  border-top: 1px solid var(--color-decor);
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;

  .swiper-container {
    margin-left: 0;
  }

  ${minWidth(vars.breakpoints.tablet + 1)`
    .swiper-wrapper {
      transform: none !important;
    }
  `}
  ${maxWidth(vars.breakpoints.tablet)`
    border-top: none;
    padding-top: 0;
    margin-top: 0;
  `}

   ${(props) =>
    props.type == 'specialist' &&
    css`
      border-top: none;
      padding-top: 0;
      gap: 10px;
      margin-top: 0;
      margin-bottom: 40px;

      ${Anchors.Item} {
        max-width: 100%;
      }
      ${Anchors.Link} {
        font-weight: 500;
        &:hover,
        &:focus {
          font-weight: 500;
          color: var(--color-decor);
        }
        &::after {
          content: '';
          width:5px;
          height:7px;
          margin-right: 10px;
          background-image: url("data:image/svg+xml,%3Csvg width='5' height='7' viewBox='0 0 5 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.96484 0.536011L1.00087 3.49999L3.96484 6.46397' stroke='%23C5C5C5' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: center;
          transition: 0.3s ease-out;
          cursor: pointer;
          order: -1;
        }
      }
    `}
`;

Anchors.Item = styled.li`
  position: relative;
  ${maxWidth(vars.breakpoints.tablet)`
    width: max-content;
  `}
`;

Anchors.Link = styled.a`
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: var(--color-secondary);
  text-transform: uppercase;
  transition: 0.3s ease-out;
  cursor: pointer;

  &:hover {
    color: var(--color-decor);
  }

  ${maxWidth(vars.breakpoints.tablet)`
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    padding-bottom: 5px;
    border-bottom: 1px solid transparent;
    transition: 0.3s ease-out;
  `}

  ${(props) =>
    props.active &&
    css`
      color: var(--color-decor);
      font-weight: 700;
      ${maxWidth(vars.breakpoints.tablet)`
      font-weight: 400;
      border-color:var(--color-decor);
      `}
    `}

  ${(props) =>
    props.arrow &&
    css`
      text-transform: unset;
      font-size: 18px;
      line-height: 27px;

      &:focus {
        color: var(--color-secondary);
        font-weight: 400;
      }
      &:hover {
        font-weight: 400;
      }
    `}

  ${(props) =>
    props.arrow &&
    props.isActive &&
    css`
      color: var(--color-decor);
      font-weight: 700;
      &:hover {
        font-weight: 700;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 21px;
        height: 27px;
        background-image: url("data:image/svg+xml,%3Csvg width='21' height='9' viewBox='0 0 21 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.3536 4.85355C20.5488 4.65829 20.5488 4.34171 20.3536 4.14645L17.1716 0.964466C16.9763 0.769204 16.6597 0.769204 16.4645 0.964466C16.2692 1.15973 16.2692 1.47631 16.4645 1.67157L19.2929 4.5L16.4645 7.32843C16.2692 7.52369 16.2692 7.84027 16.4645 8.03553C16.6597 8.2308 16.9763 8.2308 17.1716 8.03553L20.3536 4.85355ZM0 5H20V4H0V5Z' fill='%23B69B64'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-position: center;
        margin-left: 10px;
        flex-shrink:0;
      }
    `}

    ${(props) =>
      props.arrow && props.arrow == 'left'  &&
      props.isActive &&
      css`
        color: var(--color-decor);
        font-weight: 500;
        &:hover {
          font-weight: 500;
        }
        &::after {
          width:21px !important;
          height:9px !important;
          background-image: url("data:image/svg+xml,%3Csvg width='21' height='9' viewBox='0 0 21 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.646446 4.14645C0.451185 4.34171 0.451185 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM21 4L1 4V5L21 5V4Z' fill='%23B69B64' /%3E%3C/svg%3E") !important;
          margin-left:0;
        }
    `}
`;

export default Anchors;
